<template>
  <Section id="hero" tone="default" pad-y="xl" class="bg-ocean-dark">
    <Container>
      <HeroBlock
        variant="landing"
        :eyebrow="t('sections.hero.eyebrow')"
        :heading="t('sections.hero.heading')"
        :lead="t('sections.hero.lead')"
        :bullets="bullets"
        :primary-cta="primaryCta"
        :secondary-cta="secondaryCta"
        :stats="localizedStats"
        @secondary-action="clickHeroButton"
      />
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import HeroBlock from '@/components/domain/HeroBlock.vue';
import { useLocale } from '@/composables/useLocale';
import { HERO_BULLETS, HERO_BULLETS_EN, HERO_STATS, type StatItem } from '@/content/home-data';
import { pickLocalized } from '@/lib/i18n/localize';
import { useRouter } from 'vue-router';
import { yaTrackEvent } from '@/lib/metrics';

const { t } = useI18n();
const { locale } = useLocale();
const router = useRouter();

const primaryCta = computed(() => ({
  label: t('sections.hero.primaryCta'),
}));

const secondaryCta = computed(() => ({
  label: t('sections.hero.secondaryCta'),
  action: 'open-video' as const,
}));

const bullets = computed(() => (locale.value === 'en' ? HERO_BULLETS_EN : HERO_BULLETS));

const localizedStats = computed(() =>
  HERO_STATS.map((s): StatItem => ({ ...s, label: pickLocalized(s, 'label', locale.value) })),
);

const clickHeroButton = () => {
  yaTrackEvent('NewSiteOpenBrief');
  router.push(`/${locale.value}/brief`);
}
</script>
